export default __webpack_public_path__ + "static/media/MSFT.ef28ac45.svg";